import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserStateInterceptor } from './_services/browser-state-interceptor/browser-state.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieModule } from 'ngx-cookie';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import { environment } from '../environments/environment';
import localePL from '@angular/common/locales/pl';
import { AppChatService } from './_services/app/app-chat.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  TranslateHttpLoader,
  TRANSLATE_HTTP_LOADER_CONFIG,
} from '@ngx-translate/http-loader';
registerLocaleData(localePL);

// Cache-busting plików tłumaczeń. Bundle JS/HTML dostają hash przy buildzie,
// ale /assets/i18n/*.json — nie, więc przeglądarka/ingress potrafią serwować
// starą wersję po deployu (nowe klucze pokazują się wtedy jako surowe nazwy).
// Znacznik ustalany raz przy starcie aplikacji wymusza pobranie aktualnego pliku.
const I18N_CACHE_BUST = Date.now();

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        // 🔴 Service worker jest zarejestrowany BEZWARUNKOWO i domyslnie obsluguje
        // KAZDA nawigacje bez kropki w adresie — wiec u osoby, ktora byla juz na
        // stronie, wejscie na /superadmin dostaloby index.html z cache'a SW
        // i NIGDY nie dotarlo do Expressa (objaw: „dziala w incognito, nie dziala
        // normalnie"). Dlatego ngsw-config.json ma jawna liste `navigationUrls`:
        // domyslna plus wykluczenia !/superadmin, !/superadmin/** i !/api/**
        // (callback OIDC i „Wyloguj" — /api/logout/redirect, PLAN-008).
        // Pilnuje tego src/app/ngsw-navigation.spec.ts.
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        CookieModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
            fallbackLang: 'pl',
        })], providers: [
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            // prefix prefiksowany platform-aware originem (environment.assetsUrl):
            //  - browser: '' => '/assets/i18n/' (relative, same-origin)
            //  - SSR prod: 'http://localhost:${PORT}' => loopback do tego samego podu
            //    (express.static), zamiast hairpin self-fetch przez publiczny ALB.
            // dev/dv1: assetsUrl='' => zachowanie relative jak dotychczas.
            useValue: { prefix: `${environment.assetsUrl}/assets/i18n/`, suffix: `.json?v=${I18N_CACHE_BUST}` },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BrowserStateInterceptor,
            multi: true,
        },
        {
            provide: LOCALE_ID,
            useValue: 'pl',
        },
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: {
                duration: 5000,
                horizontalPosition: 'end',
                verticalPosition: 'top',
            },
        },
        { provide: 'googleTagManagerId', useValue: environment.googleTagManagerId },
        AppChatService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
